"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5428],{

/***/ 24414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmailLogin; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50319);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88641);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24824);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50261);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2453);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42561);
/* harmony import */ var _shared_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61373);
/* harmony import */ var _contexts_authToken__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43911);
/* harmony import */ var graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13492);
/* harmony import */ var redux_flash_messages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64515);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var FormItem = antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item;
var validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: '${label} is required!',
  types: {
    // eslint-disable-next-line no-template-curly-in-string
    email: '${label} is not valid!'
  }
};
function EmailLogin(_ref) {
  var callbackbeforeRedirect = _ref.callbackbeforeRedirect;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      userEmail = _useState[0],
      setuserEmail = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      userPassword = _useState2[0],
      setuserPassword = _useState2[1];

  var _useMutation = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__/* .Login_MutationDocument */ .Q0),
      _useMutation2 = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMutation, 2),
      Login = _useMutation2[0],
      data = _useMutation2[1].data;

  if (data) {
    if (callbackbeforeRedirect) {
      callbackbeforeRedirect();
    } else {
      (0,redux_flash_messages__WEBPACK_IMPORTED_MODULE_6__.addSuccess)({
        text: 'Registration Successfull'
      });
      next_router__WEBPACK_IMPORTED_MODULE_2___default().push('/');
    }
  }

  var token = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_authToken__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  var setToken = token.setToken;

  var _useMutation3 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__/* .Update_UserDocument */ .xU),
      _useMutation4 = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMutation3, 1),
      updateUser = _useMutation4[0];

  var formItemLayout = {
    wrapperCol: {
      span: 32
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread(_objectSpread({
      name: "basic",
      layout: "vertical"
    }, formItemLayout), {}, {
      className: "login-form",
      onFinish: function onFinish() {
        Login({
          variables: {
            input: {
              identifier: userEmail,
              password: userPassword
            }
          }
        }).then(function (res) {
          localStorage.setItem('authToken', res.data.login.jwt);
          localStorage.setItem('userEmail', res.data.login.user.email);
          localStorage.setItem('userId', res.data.login.user.id);
          setToken(res.data.login.jwt);
          updateUser({
            context: {
              headers: {
                Authorization: "Bearer ".concat(res.data.login.jwt)
              }
            }
          })["catch"](function (err) {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('---update err----', err);
          });
        })["catch"](function (error) {
          if (error.message === 'GraphQL error: Bad Request') {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('Invalid Email or Password');
          } else {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('Sorry Something Went Wrong!');
          }
        });
      },
      validateMessages: validateMessages,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({}, formItemLayout), {}, {
        label: "Email Address",
        name: "email",
        rules: [{
          required: true,
          type: 'email'
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          addonBefore: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}),
          placeholder: "john.doe@gmail.com",
          autoComplete: "off",
          autoFocus: true,
          onChange: function onChange(e) {
            setuserEmail(e.target.value);
          }
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({}, formItemLayout), {}, {
        name: "password",
        label: "Password",
        rules: [{
          required: true,
          message: 'Please input your Password!'
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Password */ .Z.Password, {
          addonBefore: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}),
          placeholder: "Password",
          onChange: function onChange(e) {
            setuserPassword(e.target.value);
          }
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({
        className: "m-b-0"
      }, formItemLayout), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_shared_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          type: "primary",
          size: "middle",
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}),
          className: "auth--button--login",
          htmlType: "submit",
          source: "email-login",
          children: "Login Now"
        })
      }))]
    }))
  });
}

/***/ }),

/***/ 90635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SocialLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62307);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24126);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15746);
/* harmony import */ var _shared_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var providersIcon = {
  facebook: {
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
    label: "SignIn with Facebook"
  },
  google: {
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
    label: "SignIn with Google"
  }
};
function SocialLink() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    className: "linksContainer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      span: "24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "socialLinkContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_shared_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          type: "primary",
          href: "".concat(publicRuntimeConfig.cmsRootUrl, "/api/connect/facebook"),
          style: {
            width: '100%'
          },
          className: "facebook",
          source: "facebook-login",
          children: [providersIcon.facebook.icon, providersIcon.facebook.label]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "socialLinkContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_shared_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          href: "".concat(publicRuntimeConfig.cmsRootUrl, "/api/connect/google"),
          type: "primary",
          style: {
            width: '100%'
          },
          className: "google",
          source: "google-login",
          children: [providersIcon.google.icon, providersIcon.google.label]
        })
      })]
    })
  });
}

/***/ }),

/***/ 35428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Comments; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(42561);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 20 modules
var es_form = __webpack_require__(50261);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(65239);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js + 1 modules
var divider = __webpack_require__(96074);
// EXTERNAL MODULE: ./components/auth/EmailLogin.tsx
var EmailLogin = __webpack_require__(24414);
// EXTERNAL MODULE: ./components/auth/SocialLink.tsx
var SocialLink = __webpack_require__(90635);
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
// EXTERNAL MODULE: ./contexts/authStatus.ts
var authStatus = __webpack_require__(25595);
// EXTERNAL MODULE: ./contexts/authToken.ts
var authToken = __webpack_require__(43911);
// EXTERNAL MODULE: ./graphql/generated/types.tsx
var types = __webpack_require__(13492);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
// EXTERNAL MODULE: ./node_modules/@ant-design/compatible/es/comment/index.js + 1 modules
var comment = __webpack_require__(31105);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UserOutlined.js + 1 modules
var UserOutlined = __webpack_require__(87547);
// EXTERNAL MODULE: ./node_modules/antd/es/avatar/index.js + 8 modules
var avatar = __webpack_require__(37911);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/comments/RenderComment.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var TextArea = input/* default.TextArea */.Z.TextArea;
function RenderComment(_ref) {
  var _item$author, _item$children;

  var item = _ref.item,
      parent = _ref.parent,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 0 : _ref$level,
      id = _ref.id,
      setmodalVisible = _ref.setmodalVisible,
      setComments = _ref.setComments,
      status = _ref.status,
      style = _ref.style,
      related = _ref.related;

  var _useState = (0,react.useState)(false),
      toggle = _useState[0],
      setToggle = _useState[1];

  var _useState2 = (0,react.useState)(null),
      currId = _useState2[0],
      setCurrId = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      currentUserToken = _useState3[0],
      setCurrentUserToken = _useState3[1];

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var margin = "".concat(5 * level, "rem");

  var _useMutation = (0,useMutation/* useMutation */.D)(types/* CreateCommentDocument */.al, {
    context: {
      headers: {
        Authorization: "Bearer ".concat(currentUserToken)
      }
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      AddComment = _useMutation2[0];

  (0,react.useEffect)(function () {
    var _localStorage;

    if ((_localStorage = localStorage) !== null && _localStorage !== void 0 && _localStorage.authToken) {
      setCurrentUserToken(localStorage.authToken);
    }
  }, []); //  handling state on appending children comment

  var hadleCommentUpdate = function hadleCommentUpdate(updatedComment) {
    var Id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    // eslint-disable-next-line
    var childComments = Id ? parent.children.map(function (comment) {
      return comment.id === Id ? updatedComment : comment;
    }) : parent.children ? [updatedComment].concat((0,toConsumableArray/* default */.Z)(parent.children)) : [updatedComment];

    var updatedParent = _objectSpread(_objectSpread({}, parent), {}, {
      children: childComments
    });

    setComments(updatedParent, parent.id);
  };

  var handleReply = function handleReply(e) {
    setToggle(!toggle);
    setCurrId(e.id);
  };

  var submitComment = function submitComment(content) {
    AddComment({
      variables: {
        input: {
          content: content,
          relation: "".concat(related, ":").concat(id),
          threadOf: currId,
          author: {
            id: localStorage.getItem('userId'),
            name: localStorage.getItem('userEmail').split('@')[0],
            email: localStorage.getItem('userEmail'),
            avatar: localStorage.getItem('profileUrl')
          }
        }
      }
    }).then(function (response) {
      form.resetFields();
      hadleCommentUpdate(response.data.createComment);
      setToggle(false);
      setmodalVisible(false);
    })["catch"](function (err) {
      if (err.status === 403) {
        localStorage.setItem('message', content.comment);
        message/* default.info */.ZP.info('Please login again to continue..');
        setmodalVisible(true);
      } else {
        message/* default.error */.ZP.error('Sorry Something Went Wrong!');
      }
    });
  };

  var handleAddComment = function handleAddComment(values) {
    if (currentUserToken) {
      // Submiting Comment
      submitComment(values.comment);
    } else {
      localStorage.setItem('message', values.comment);
      localStorage.setItem('parentId', currId);
      setmodalVisible(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(comment/* default */.Z, {
      actions: level < 3 && [status === 'APPROVED' && /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
        type: "link",
        block: true,
        id: item.id,
        onClick: function onClick() {
          return handleReply(item);
        },
        source: "comment-reply",
        children: "Reply to"
      }, item.id) // <span key={item.id} id={item.id} onClick={() => handleReply(item)}>
      //   Reply to
      // </span>,
      ],
      content: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        id: item.id,
        style: style,
        children: item.content
      }),
      author: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: item === null || item === void 0 ? void 0 : (_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.name
      }),
      avatar: item.author.avatar ? /*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.C, {
        src: item.author.avatar
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.C, {
        size: 55,
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(UserOutlined/* default */.Z, {})
      }) // datetime={dateformat(item.createdAt, 'dddd, mmmm dS, yyyy, h:MM TT')}
      ,
      style: {
        marginLeft: margin
      }
    }, item.id), toggle && /*#__PURE__*/(0,jsx_runtime.jsxs)(es_form/* default */.Z, {
      form: form,
      name: "basic",
      style: {
        marginLeft: "".concat(5 * level, "rem")
      },
      onFinish: function onFinish(e) {
        return handleAddComment(e);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
        name: "comment",
        rules: [{
          required: true,
          message: 'Please type Comment to continue...'
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
          rows: 4
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
          type: "primary",
          htmlType: "submit",
          source: "add-comment",
          children: "Submit"
        })
      })]
    }), (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map(function (itemChild) {
      return ['APPROVED', 'PENDING'].includes(itemChild.approvalStatus) && /*#__PURE__*/(0,jsx_runtime.jsx)(RenderComment, {
        style: itemChild.approvalStatus === 'PENDING' ? {
          color: '#CAC7CE'
        } : {
          color: ''
        },
        parent: itemChild,
        item: itemChild,
        level: level + 1,
        id: id,
        setmodalVisible: setmodalVisible,
        setComments: hadleCommentUpdate,
        status: itemChild.approvalStatus,
        related: related
      }, itemChild.id);
    })]
  });
}
;// CONCATENATED MODULE: ./components/comments/Comments.tsx






function Comments_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Comments_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Comments_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Comments_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import dateformat from 'dateformat'














var Paragraph = typography/* default.Paragraph */.Z.Paragraph,
    Title = typography/* default.Title */.Z.Title;
var Comments_TextArea = input/* default.TextArea */.Z.TextArea;
function Comments(_ref) {
  var articleData = _ref.articleData,
      related = _ref.related;

  var _useState = (0,react.useState)(articleData.attributes.plugin_comments),
      comments = _useState[0],
      setComments = _useState[1];

  var _useState2 = (0,react.useState)(null),
      currentUserToken = _useState2[0],
      setCurrentUserToken = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      modalVisible = _useState3[0],
      setmodalVisible = _useState3[1];

  var login = (0,react.useContext)(authStatus/* default */.Z);
  var setLogin = login.setLogin;
  var level = 0;

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  (0,react.useEffect)(function () {
    var _localStorage;

    if ((_localStorage = localStorage) !== null && _localStorage !== void 0 && _localStorage.authToken) {
      setCurrentUserToken(localStorage.authToken);
    }
  }, []);
  (0,react.useEffect)(function () {
    setComments(articleData.attributes.plugin_comments);
  }, [articleData.attributes.plugin_comments]);

  var _useContext = (0,react.useContext)(authToken/* default */.Z),
      jwt = _useContext.jwt;

  var _useMutation = (0,useMutation/* useMutation */.D)(types/* CreateCommentDocument */.al),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      AddComment = _useMutation2[0];

  var count = (0,util/* countComments */.Mw)(comments);

  var submitComment = function submitComment(content) {
    var input = {
      content: content,
      relation: "".concat(related, ":").concat(articleData.id),
      author: {
        id: localStorage.getItem('userId'),
        name: localStorage.getItem('userEmail').split('@')[0],
        email: localStorage.getItem('userEmail'),
        avatar: localStorage.getItem('profileUrl')
      }
    };

    if (localStorage.getItem('parentId')) {
      input = Comments_objectSpread(Comments_objectSpread({}, input), {}, {
        threadOf: localStorage.parentId
      });
    }

    AddComment({
      variables: {
        input: Comments_objectSpread({}, input)
      },
      context: {
        headers: {
          Authorization: "Bearer ".concat(jwt !== null && jwt !== void 0 ? jwt : currentUserToken)
        }
      }
    }).then(function (response) {
      if (!localStorage.parentId) {
        setComments([response.data.createComment].concat((0,toConsumableArray/* default */.Z)(comments)));
      } // setInputValue(null)


      if (localStorage.parentId) {
        router_default().reload();
      }

      localStorage.removeItem('parentId');
      form.resetFields();
      setmodalVisible(false);
    })["catch"](function (err) {
      if (err.status === 403) {
        localStorage.setItem('message', content);
        message/* default.info */.ZP.info('Please login again to continue..');
        setmodalVisible(true);
      } else {
        message/* default.error */.ZP.error('Sorry Something Went Wrong!');
      }
    });
  };

  var handleAddComment = function handleAddComment(values) {
    if (currentUserToken) {
      // Submiting Comment
      submitComment(values.comment);
    } else {
      localStorage.setItem('message', values.comment);
      setmodalVisible(true);
    }
  };

  var handleCancel = function handleCancel() {
    setmodalVisible(false);
  }; // Modal


  var sumbitContentCallback = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var tempMessage;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tempMessage = localStorage.message;
              localStorage.removeItem('message');
              setLogin(true);

              if (!tempMessage) {
                _context.next = 10;
                break;
              }

              _context.next = 6;
              return setCurrentUserToken(localStorage.authToken);

            case 6:
              submitComment(tempMessage);
              message/* default.info */.ZP.info('Successfully Logged In!');
              message/* default.info */.ZP.info('Your message has been added successfully.');
              router_default().reload();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sumbitContentCallback() {
      return _ref2.apply(this, arguments);
    };
  }(); //  managing state for children comments


  var handleCommentUpdate = function handleCommentUpdate(updatedComment) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var updatedComments = id ? comments.map(function (comment) {
      return comment.id === id ? updatedComment : comment;
    }) : [].concat((0,toConsumableArray/* default */.Z)(comments), [updatedComment]);
    setComments(updatedComments);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      span: 24,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        level: 5,
        type: "secondary",
        style: {
          textAlign: 'center'
        },
        children: "Ask Your Query for FREE, Get quick answers from our FINTRAKK community!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        level: 5,
        style: {
          color: '#1890ff',
          marginBottom: 0
        },
        children: ["Discussion (", count, ")"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(es_form/* default */.Z, {
        form: form,
        name: "basic",
        onFinish: handleAddComment,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
          name: "comment",
          rules: [{
            required: true,
            message: 'Please type Comment to continue...'
          }],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Comments_TextArea, {
            rows: 4
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
            type: "primary",
            htmlType: "submit",
            source: "add-comment",
            children: "Submit"
          })
        })]
      }), (comments === null || comments === void 0 ? void 0 : comments.length) > 0 && comments.map(function (comment) {
        return ['APPROVED', 'PENDING'].includes(comment.approvalStatus) && /*#__PURE__*/(0,jsx_runtime.jsx)(RenderComment, {
          parent: comment,
          id: articleData.id,
          item: comment,
          setmodalVisible: setmodalVisible,
          setComments: handleCommentUpdate,
          level: level,
          status: comment.approvalStatus,
          style: comment.approvalStatus === 'PENDING' ? {
            color: '#CAC7CE'
          } : {
            color: ''
          },
          related: related
        }, comment.id);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal/* default */.Z, {
      title: "Please Login to Discuss",
      open: modalVisible,
      footer: null,
      onCancel: handleCancel,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "authPage",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          className: "formContainer",
          style: {
            marginTop: '32px'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: "24",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
              className: "row",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
                span: "24",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SocialLink/* default */.Z // callbackbeforeRedirect={() => sumbitContentCallback()}
                , {}), /*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
                  children: "or"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
                  children: "Please enter your details to login."
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailLogin/* default */.Z, {
                  callbackbeforeRedirect: function callbackbeforeRedirect() {
                    return sumbitContentCallback();
                  }
                })]
              })
            })
          })
        })
      })
    })]
  });
} // ArticleComments.propTypes = {
//   articleData: PropTypes.shape({
//     id: PropTypes.string.isRequired,
//     article_comments: PropTypes.arrayOf({
//       content: PropTypes.string.isRequired,
//       created_at: PropTypes.string.isRequired,
//       user: PropTypes.shape({
//         username: PropTypes.string.isRequired,
//       }),
//     }).isRequired,
//   }).isRequired,
// }

/***/ })

}]);